module.exports = __webpack_public_path__ + "img/36_37.d6e243ef.png";